import { render, staticRenderFns } from "./Day21.vue?vue&type=template&id=815a56c4"
import script from "./Day21.vue?vue&type=script&lang=js"
export * from "./Day21.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports